<button class="btn btn-ltBlue" (click)="cancelPrintChecksSession()">Cancel Print Session</button>
